import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Check, Sparkles, Crown, Zap } from "lucide-react";
import { PublicPage } from "../components/PublicPage";
import { trackEvent } from "../lib/analytics";

const PLANS = [
  {
    key: "FREE", name: "Free", icon: Zap, price: "0€", period: "",
    tagline: "La boucle Cehnura, gratuitement.",
    features: ["Projets & tâches", "XP, niveaux & progression", "Preuves texte & image", "Marketplace (parcourir)"],
    cta: "Commencer gratuitement", highlight: false,
  },
  {
    key: "PREMIUM", name: "Premium", icon: Sparkles, price: "19,90€", period: "/mois",
    tagline: "Preuves média, coach avancé, sorties.",
    features: ["Tout Free", "Projets illimités", "Coach avancé", "Smart Release Planner", "Content Studio", "Analytics avancées"],
    cta: "Choisir Premium", highlight: true,
  },
  {
    key: "PRO", name: "Pro", icon: Crown, price: "49,90€", period: "/mois",
    tagline: "Growth, Autopilot & automatisations.",
    features: ["Tout Premium", "Growth / Audience", "Marketing Autopilot", "Connecteurs externes", "IA avancée", "Automatisations"],
    cta: "Choisir Pro", highlight: false,
  },
];

export default function Tarifs() {
  useEffect(() => { trackEvent("pricing_viewed", { source: "tarifs" }); }, []);
  return (
    <PublicPage title="Tarifs" subtitle="Commence gratuitement, passe à la vitesse supérieure quand tu es prêt." testid="pricing-page">
      <div className="grid gap-4 md:grid-cols-3 mt-2">
        {PLANS.map((p) => {
          const Icon = p.icon;
          return (
            <div key={p.key} data-testid={`pricing-card-${p.key}`}
              className={`rounded-3xl p-6 border flex flex-col ${p.highlight ? "border-amber-500/60 bg-amber-500/5 glow-gold" : "border-zinc-800 bg-[#18181E]"}`}>
              <div className="flex items-center gap-2 mb-1">
                <Icon className="w-5 h-5 text-amber-400" />
                <span className="font-display text-xl font-bold">{p.name}</span>
                {p.highlight && <span className="ml-auto text-[10px] px-2 py-0.5 rounded-full bg-amber-500/20 text-amber-400 border border-amber-500/40">Populaire</span>}
              </div>
              <p className="text-xs text-zinc-500 mb-3">{p.tagline}</p>
              <p className="font-display text-3xl font-extrabold mb-4">{p.price}<span className="text-sm text-zinc-500 font-normal">{p.period}</span></p>
              <ul className="space-y-2 flex-1 mb-5">
                {p.features.map((f) => (
                  <li key={f} className="flex items-center gap-2 text-sm text-zinc-300"><Check className="w-4 h-4 text-emerald-400 shrink-0" /> {f}</li>
                ))}
              </ul>
              <Link to="/register" data-testid={`pricing-cta-${p.key}`}
                className={`w-full h-11 rounded-xl font-semibold flex items-center justify-center transition-opacity ${p.highlight ? "gold-gradient text-black hover:opacity-90" : "border border-zinc-700 text-zinc-200 hover:bg-zinc-900"}`}>
                {p.cta}
              </Link>
            </div>
          );
        })}
      </div>
      <p className="text-xs text-zinc-500 text-center mt-6">Paiements sécurisés par Stripe · Sans engagement · Résiliable à tout moment · Espace Manager gratuit.</p>
    </PublicPage>
  );
}
